// @flow

import type {Language, ModalType} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {appSelectors, formActions} from '@/store'

import BaseModal from './base-modal'
import Form from './form'
import {isEmpty} from 'ramda'

type Props = {
  modalComponent: any,
  modalProps: Object,
  modalType: ?ModalType,
  modalError: ?string,
  formData: ?Object,
  clearForm: () => void,
  l: Language,
}

const renderInfoModal = (props) =>
  <BaseModal
    showConfirm={false}
    showCancel={false}
    showExport={false}
    title={props.l(props.modalProps.title)}
    onCancel={props.modalProps.onCancel}
  >
    <props.modalComponent {...props.modalProps} />
  </BaseModal>

const renderConfirmModal = (props) =>
  <BaseModal
    title={`${props.l('Are you sure')}?`}
    onCancel={props.modalProps.onCancel}
    onConfirm={props.modalProps.onConfirm}
    message={`${props.l(props.modalProps.message)}`}
  >
  </BaseModal>

const renderEditModal = (props: Props) =>
  <BaseModal
    title={props.l(props.modalProps.title)}
    preventConfirm={!props.formData}
    onCancel={props.modalProps.onCancel}
    onConfirm={props.modalProps.onConfirm}
    afterConfirm={isEmpty(props.modalError) ? props.clearForm : () => {}}
    afterCancel={props.clearForm}
    type={props.modalProps.type}
  >
    <Form />
  </BaseModal>

export const RawModalContainer = (props: Props) => {
  switch (props.modalType) {
    case 'info':
      return renderInfoModal(props)
    case 'confirm':
      return renderConfirmModal(props)
    case 'edit':
      return renderEditModal(props)
    default:
      return null
  }
}

const mapStateToProps = (state) => ({
  modalType: state.ui.modal.type,
  modalComponent: state.ui.modal.component,
  modalProps: state.ui.modal.props || {},
  modalError: state.ui.modal.error,
  formData: state.form.data,
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
  formActions,
)(RawModalContainer)



// WEBPACK FOOTER //
// ./src/views/modals/index.js